import React from 'react';
import withView from '../../cmn/docAutomation/withView';
// import SarasDnDProvider from '../../../library/hooks/bdnd/SarasDnDProvider';
// import { SarasDnDTypes } from '../../../library/hooks/bdnd/SarasDnDTypes';
// import useSarasDnDManager from '../../../library/hooks/bdnd/useSarasRegularDnDManager'
import SarasDnDProvider from '../../../library/hooks/dndkit/SarasDnDProvider';
import { SarasDnDTypes } from '../../../library/hooks/dndkit/SarasDnDTypes';
import useSarasDnDManager from '../../../library/hooks/dndkit/useSarasRegularDnDManager'
import DocImageRowDNDList from './DocImageRowDNDList';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormWrapper from '../../../library/form/components/FormWrapper';
import ActionButton from '../../../library/input/buttons/button/SarasButton';
import FormTitle from '../../../library/form/components/FormTitle';
import { UiView, UiViewHeading, UiAction, UiTitle, UiViewContent } from "../../../library/layout/Index";

const DocImage = (props) => {
    const { formObject, viewData } = props;

    const [rowKeys, setRowKeys] = React.useState([]);

    React.useEffect(() => {
        if(viewData)
        {
            setRowKeys(Object.keys(viewData));
        }
    }, [viewData]);

    const moveServerItem = (sourceRow, previousRow) => {
        // console.log("doc image sort payload", {
        //     movedElementId: sourceRow ? sourceRow.rowId : null,
        //     nextToElementId: previousRow ? previousRow.rowId : "0",
        //     sourceRow,
        //     previousRow,
        // });

        let customAction = {
            actionId: "refresh",
            actionName: "docImage",
            actionParam: {
                rearrange: "1",
                movedElementId: sourceRow.rowId,
                nextToElementId: previousRow ? previousRow.rowId :"0",
            },
            containerKey: "custom"
        };

        formObject.onFormAction(customAction, "", null);
    }

    const onDragEnd = (result) => {
        let dropResult = sarasDnDManager.onDragEnd(viewData, rowKeys, result);
        
        if(!dropResult) return;

        console.log("doc image drag end", {
            result,
            dropResult,
            rowKeysBefore: rowKeys,
        });

        setRowKeys(dropResult.rowKeys);

        //call code to reorder on server
        moveServerItem(dropResult.sourceRow, dropResult.previousRow);
    }

    const sarasDnDManager = useSarasDnDManager(SarasDnDTypes.CARD, false);

    const onSortToggleClick = () => {
        sarasDnDManager.onToggleSort();

        let customAction = {
            actionId: "show"
        };

        formObject.onFormAction(customAction, "", null);
    }

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Image' />
                </UiTitle>
                <UiAction>
                    <FormWrapper customWrapper="span" formObject={formObject} headerKey="header" action={{ paramName: "viewIsActive" }} >
                        <ActionButton  
                                className=""
                                onClick={onSortToggleClick} 
                                starIcon={"sort"} text="Toggle Sort Mode" />
                    </FormWrapper>
                    <FormButton formObject={formObject} headerKey="header" starIcon={"adds"}
                            action={{ actionId: "new", paramName:"viewIsActive", actionParam: {}, containerKey: "popup" }}
                            className="" text="Image"></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <SarasDnDProvider onDragEnd={onDragEnd} sarasDnDManager={sarasDnDManager}>
                    <DocImageRowDNDList formObject={formObject} viewData={viewData} 
                    rowKeys={rowKeys}
                    sarasDnDManager={sarasDnDManager} />
                </SarasDnDProvider>
            </UiViewContent>
        </UiView>
    )
}

export default withView(DocImage, "docImage", "docImage")
